import React, { useEffect, useMemo, useState } from 'react';
import CorpayXAlphaFr from 'assets/Corpay x Alpha LockUp_French - Corporate - Horizontal - White.svg';
import CorpayXAlphaDe from 'assets/Corpay x Alpha LockUp_German - Corporate - Horizontal - White.svg';
import CorpayXAlphaIt from 'assets/Corpay x Alpha LockUp_Italian - Corporate - Horizontal - White.svg';
import CorpayXAlphaEs from 'assets/Corpay x Alpha LockUp_Spanish - Corporate - Horizontal - White.svg';
import CorpayBannerBackground from 'assets/CorpayBannerBackground.png';
import CorpayXAlphaEn from 'assets/CorpayXAlpha.png';
import { components } from 'generated/payment-initialisation/schema';
import i18n from 'i18n/config';
import routes from 'routes.path';
import ConfigService from 'services/Config/config.service';
import history from 'services/history/browserHistory';
import t from 'utils/translationHelper';

import { APTooltip } from '@alpha/ui-lib/ui/Tooltip';
import { faExternalLink, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStyles } from './CorpayBanner.styles';

const CorpayBanner = (): React.ReactElement => {
  const styles = useStyles();
  const [migrationReadiness, setMigrationReadiness] = useState<components['schemas']['MigrationReadinessResponse']>(null);

  const getMigrationReadiness = async () => {
    const migrationReadinessResponse = await ConfigService.getMigrationReadiness();
    return migrationReadinessResponse;
  };

  const accountConfig = JSON.parse(localStorage.getItem('account-info') || '{}');

  useEffect(() => {
    const fetchMigrationReadiness = async () => {
      const response = await getMigrationReadiness();
      setMigrationReadiness(response);
    };
    fetchMigrationReadiness();
  }, []);

  const alphaCorpayLogoToUse = useMemo(() => {
    switch (i18n.language) {
      case 'en':
        return CorpayXAlphaEn;
      case 'fr':
        return CorpayXAlphaFr;
      case 'es':
        return CorpayXAlphaEs;
      case 'it':
        return CorpayXAlphaIt;
      case 'de':
        return CorpayXAlphaDe;
      default:
        return CorpayXAlphaEn;
    }
  }, [i18n.language]);

  return (
    <div className={styles.root}>
      <div className={styles.imageWrapper}>
        <img src={alphaCorpayLogoToUse} alt="Banner" className={styles.logo} />
      </div>
      <img
        src={CorpayBannerBackground}
        alt="BannerBackground"
        className={styles.backgroundImage}
      />
      <div className={styles.buttonsWrapper}>
        <button
          type="button"
          className={styles.primaryButton}
          onClick={() => window.open('https://www.alphagroup.com/corpay/', '_blank')}
        >
          {t('aquisition_announcement')}
          <FontAwesomeIcon icon={faExternalLink} style={{ marginLeft: '8px' }} />
        </button>
        {accountConfig.dataCenterVersion === 'Corpay Migration Center' && (
          <APTooltip
            arrow
            title={(
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                minWidth: '256px',
                fontSize: '13px',
              }}
              >
                <div style={{ fontWeight: 600 }}>
                  {t('migration_readiness')}
                  :
                  {' '}
                  {migrationReadiness?.TotalReadinessPercentage ?? '-'}
                  %
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <div style={{ fontWeight: 600 }}>
                    {(migrationReadiness?.TotalEligibleBeneficiaries ?? 0) - (migrationReadiness?.EligibleBeneficiariesReady ?? 0)}
                  </div>
                  {t('beneficiaries_missing_data')}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <div style={{ fontWeight: 600 }}>
                    {(migrationReadiness?.TotalEligibleRemitters ?? 0) - (migrationReadiness?.EligibleReittersReady ?? 0)}
                  </div>
                  {t('remitters_missing_data')}
                </div>
              </div>
)}
          >
            <button
              type="button"
              className={styles.secondaryButton}
              onClick={() => history.push(routes.migrationReadiness)}
            >
              <FontAwesomeIcon icon={faInfoCircle} style={{ marginRight: '8px' }} />
              {t('migration_readiness')}
              :
              {' '}
              {migrationReadiness?.TotalReadinessPercentage ?? '-'}
              %
            </button>
          </APTooltip>
        )}
      </div>
    </div>
  );
};

export default CorpayBanner;
